<script setup lang="ts">
const { sortedSidebarFiles } = useSidebar()
const { state: gestureState } = useGestures()
const { sidebarFavoritesId } = useGlobals()

function showInsertBefore(fractionalIndex: string) {
  if (!isDefined(gestureState.value.sidebarFavoritesDraggedBetween))
    return false
  return fractionalIndex === gestureState.value.sidebarFavoritesDraggedBetween[1]
}

function showInsertAfter() {
  if (!isDefined(gestureState.value.sidebarFavoritesDraggedBetween))
    return false
  if (isDefined(gestureState.value.sidebarFavoritesDraggedBetween[1]))
    return false
  return true
}
</script>

<template>
  <sidebar-section :id="sidebarFavoritesId">
    <template #label>
      Favorites
    </template>
    <template #default>
      <div class="files">
        <template v-for="{ fractionalIndex, file } in sortedSidebarFiles" :key="fractionalIndex">
          <div v-if="showInsertBefore(fractionalIndex)" class="drop-placeholder" />
          <sidebar-entry-file
            :fractional-index
            :file
            :hoverable="gestureState.gesture !== 'drag-file'"
            :drag-over="gestureState.sidebarFavoritesFileDraggedOver?.fileId === file.fileId"
          />
        </template>
        <div v-if="showInsertAfter()" class="drop-placeholder" />
      </div>
    </template>
  </sidebar-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.files
  @apply flex flex-col gap-[#{$sidebar-gap-items-container}]

.drop-placeholder
  @apply h-[2px] bg-[#{$menu-b-separator}] rounded-[#{$sidebar-br-item-hovered}] my-[2px] -mx-[6px]
</style>
